/*
 *
 * Error actions
 *
 */

import {
  DEFAULT_ACTION,
  SHOW_TOAST,
  HIDE_TOAST,
  RESET_ERROR_TITLE,
  RESET_TWO_FACTOR_VERIFICATION,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export const showToast = data => ({ type: SHOW_TOAST, data });

export const hideToast = () => ({ type: HIDE_TOAST });

export const resetErrorTitle = () => ({ type: RESET_ERROR_TITLE });

export const resetTwoFactorAuthentication = data => ({
  type: RESET_TWO_FACTOR_VERIFICATION,
  data,
});
